import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "m-auto px-8 md:px-20 pb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("h1", { class: "pt-5 text-xl font-bold" }, "Configurazioni delle business unit", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm" }, "Questa pagina è visibile solamente ad utenti con specifici permessi", -1)),
      (_ctx.buLabelFromFascePermission.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "py-5 font-bold" }, "Fasce di ricavo", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buLabelFromFascePermission, (bu) => {
              return (_openBlock(), _createBlock(_component_NextButton, {
                component: "router-link",
                to: {name:'FasceDiRicavo', params:{id :bu?.id || 0}},
                class: "p-2 mb-3 mr-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(bu?.nome), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 256))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.buLabelFromBilanciPermission.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "py-5 font-bold" }, "Previsionale commerciale", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buLabelFromBilanciPermission, (bu) => {
              return (_openBlock(), _createBlock(_component_NextButton, {
                component: "router-link",
                to: {name:'BilanciPrevisionaliBu',params:{id:bu?.id || 0}},
                class: "p-2 mb-3 mr-3"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(bu?.nome), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 256))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Inserimento dati contabilità generali ", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aziende_contabilita, (a) => {
        return (_openBlock(), _createBlock(_component_NextButton, {
          component: "router-link",
          to: {name:'ContabilitaAzienda', params:{id:a?.id || 0}},
          class: "p-2 mb-3 mr-3"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(a.nome), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 256))
    ])
  ], 64))
}